export const CONTACT = {
    emails: ["prateekkapoor323@gmail.com", "anupkapoor92@gmail.com"],
    phones: ["+91-9654019428", "+91-9654019427"],
    address: "Gurunanak Compund, 401, Patel Marg, Ghaziabad, 201002, Uttar Pradesh",
    whatsapp: "+91-9654019427",
    mapsUrl: "https://maps.app.goo.gl/XFsBvJeUUbnuZVzGA",
    mapsEmbed: "https://maps.google.com/maps?q=28.6687449,77.422019&z=16&output=embed",
};

const img = (id, w = 1400) =>
    `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1756477436005-8ac1d0ecb78b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwc3RlZWwlMjBmYWJyaWNhdGlvbiUyMGRhcmt8ZW58MHx8fHwxNzgxOTAwMjk5fDA&ixlib=rb-4.1.0&q=85",
    legacy: img("photo-1666618090858-fbcee636bd3e"),
};

export const PRODUCTS = [
    {
        name: "Parallel Keys",
        tag: "Torque transmission, zero slip",
        description:
            "Feather and parallel keys machined to DIN 6885 (ISO 773) standard for precise shaft-and-hub fits. Manufactured in EN8 and Mild Steel (MS), from 6×6 mm up to 50×28 mm cross-sections with lengths to 1000 mm — custom sizes made to order.",
        specs: ["DIN 6885 / ISO 773", "EN8 Steel", "Mild Steel (MS)", "Custom sizes"],
        image: "/products/parallel-keys.jpg",
        alt: "Parallel keys DIN 6885 EN8 and mild steel — First Choice Trading Company Ghaziabad",
        span: "lg:col-span-3",
    },
    {
        name: "Lead Screws",
        tag: "True threads, smooth linear motion",
        description:
            "Trapezoidal and square-thread lead screws with matching nuts, cut true for backlash-free linear movement in presses, vices and machine slides. EN8 and MS, turned or ground finish.",
        specs: ["Trapezoidal thread", "EN8 / MS", "Nuts included"],
        image: img("photo-1671404910386-8c2a9ae40efd"),
        alt: "Trapezoidal lead screws with nuts manufacturer India",
        span: "lg:col-span-3",
    },
    {
        name: "Shafts",
        tag: "Turned & ground to tight tolerance",
        description:
            "Turned, ground and polished shafts for gearboxes, rollers and drive assemblies. EN8, EN19 and MS in any diameter or length, machined exactly to your drawing.",
        specs: ["Ground finish", "EN8 / EN19 / MS", "Made to drawing"],
        image: img("photo-1666634157070-6fd830fb5672"),
        alt: "Ground and turned machine shafts EN8 EN19 manufacturer",
        span: "lg:col-span-3",
    },
    {
        name: "Slide Plates",
        tag: "Wear plates for heavy slideways",
        description:
            "Wear-resistant slide plates and guide strips for slideways, presses and heavy machinery beds. Machined flat, drilled or countersunk to your hole pattern, any thickness.",
        specs: ["Wear resistant", "Drilled to pattern", "Any thickness"],
        image: img("photo-1548683726-203119be6a39"),
        alt: "Wear resistant slide plates for heavy machinery slideways",
        span: "lg:col-span-3",
    },
    {
        name: "MS Rollers",
        tag: "Mild steel rollers, true & balanced",
        description:
            "Mild steel conveyor, guide and table rollers machined true and balanced for smooth, long-running service. Custom diameters, lengths and shaft ends made to your drawing.",
        specs: ["Mild Steel (MS)", "Custom dia & length", "Balanced & true"],
        image: img("photo-1681108212545-04cabe9cf771"),
        alt: "Mild steel MS conveyor and guide rollers manufacturer",
        span: "lg:col-span-3",
    },
    {
        name: "Custom Machine Parts",
        tag: "Built-to-print development",
        description:
            "Send a drawing or even a worn sample — we develop and machine the component, from one-off prototypes to repeat batch production, backed by 40 years of shop-floor experience.",
        specs: ["Built to print", "Prototype to batch", "40 yrs experience"],
        image: img("photo-1713371398484-cc4e4f6a262a"),
        alt: "Custom machine parts built to print — precision machining Ghaziabad",
        span: "lg:col-span-3",
    },
];

export const INDUSTRIES = [
    {
        name: "Wire Drawing Machine Manufacturers",
        note: "Keys, shafts & wear parts that keep drawing lines running shift after shift.",
        image: img("photo-1735494033576-9c882e80504c", 900),
    },
    {
        name: "Rolling Mill Manufacturers",
        note: "Heavy-duty machined components built for the loads of the mill floor.",
        image: img("photo-1532186773960-85649e5cb70b", 900),
    },
    {
        name: "Cement Plant Machineries",
        note: "Abrasion-ready slide plates and drive parts for punishing plant conditions.",
        image: img("photo-1713371398485-7bde1bde9def", 900),
    },
    {
        name: "Gear Box Manufacturers",
        note: "Precision keys and shafts that seat right the first time, every time.",
        image: "https://images.unsplash.com/photo-1524514587686-e2909d726e9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxoZWF2eSUyMG1hY2hpbmVyeSUyMGdlYXIlMjBib3h8ZW58MHx8fHwxNzg2MjE0OTYxfDA&ixlib=rb-4.1.0&q=85",
    },
];

export const NAV_LINKS = [
    { index: "01", label: "Legacy", href: "#legacy" },
    { index: "02", label: "Products", href: "#products" },
    { index: "03", label: "Industries", href: "#industries" },
    { index: "04", label: "Contact", href: "#contact" },
];
